import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import useFetch, { CacheTime } from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { EquipmentKits } from "./type.ts";

const useEquipmentKits = () => {
  const fetch = useFetch();

  const { data, isFetching, isError } = useQuery<EquipmentKits[] | null, Error, EquipmentKits[]>({
    queryKey: ["equipment-kits"],
    queryFn: () =>
      fetch<EquipmentKits[]>(`${Urls.EquipmentKits}`, {
        method: "GET",
      }),
    gcTime: CacheTime,
    staleTime: CacheTime,
  });

  useEffect(() => {
    if (isError) {
      toast.error("Error getting equipment kits");
    }
  }, [isError]);

  return {
    kits: data,
    isFetching,
  };
};

export default useEquipmentKits;
